import {ImageLoader, modulo } from 'libs';

class Sprite {
	constructor(element){		
		this.element = element;
		this.nbrFrame = parseInt(element.dataset.number);
		this.path = element.dataset.path;
		this.category = element.dataset.category;
		this.loader =  new ImageLoader;
		this.startIndex = 1;
		this.currentIndex = this.startIndex;
		this.int;
		this.frameRate = 1000/30;

		this.loop = false;
	};

	async load(){
		const urls = [];		
		for(let i = this.startIndex ; i <= this.nbrFrame ; i++){
			urls.push(this.getImgUrl(i));
		}
		await this.loader.load(urls);
	}
 
	play(reverse){		
		clearInterval(this.int);
		let dest = reverse ? this.startIndex : this.nbrFrame;		
		if(dest == this.currentIndex) return;
		this.int =  setInterval( () =>{

			if(this.loop){
				this.currentIndex = modulo(this.currentIndex + (reverse ? -1 : 1), this.nbrFrame);
			}
			else reverse ? this.currentIndex-- : this.currentIndex++;
			
			
			if (this.currentIndex == dest) clearInterval(this.int);		
			this.element.src =  this.loader.get(this.getImgUrl(this.currentIndex)).src;			
		}, this.frameRate);
	}

	reverse(){
		
		this.play(true);
	}

	reset(){		
		clearInterval(this.int);		
		this.element.src = this.loader.get(this.getImgUrl(1)).src;
	}	

	getImgUrl(index){
		return this.path+"/"+this.category+"/"+index.toString().padStart(4,'0')+".png";
	}

}

export  { Sprite }